// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#nav-item-shortcut .fas.quick-add[data-v-1c5cedcc]{margin-right:3px;color:#678f35}", ""]);
// Exports
module.exports = exports;
